import { render } from "./AssortmentSaveButtons.vue?vue&type=template&id=159ad988&scoped=true"
import script from "./AssortmentSaveButtons.vue?vue&type=script&lang=js"
export * from "./AssortmentSaveButtons.vue?vue&type=script&lang=js"

import "./AssortmentSaveButtons.vue?vue&type=style&index=0&id=159ad988&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159ad988"]])

export default __exports__